import {UIModuleV2} from '@gongxigames/framework/slotV2/baseClasses/uiModuleV2/UiModuleV2';
import {CoreDI, inject, LAYERS, Signal, SlotSettings, Store} from '@gongxigames/framework/slot';
import {CounterData} from '@gongxigames/framework/promotions';
import {Container} from 'pixi.js';
import {$UIKoalaPromotionCounter} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIPromotionCounter/components/UIKoalaPromotionCounter';

export class UIKoalaPromotionCounterModule extends UIModuleV2 {
    static NAME = 'UIKoalaPromotionCounterModule';
    public static layer = LAYERS.KEYPAD;
    public container = new Container();

    protected showCounterSignal = Store.signal(false);
    protected promotionCount!: Signal<CounterData>;
    protected active = false;

    // TODO convert to signals/move to store
    @inject(CoreDI.Settings)
    protected _settings!: SlotSettings;

    onInit(): void {
        this.promotionCount = Store.signal({left: 1, total: 3, bet: 125});
        const frCounter = $UIKoalaPromotionCounter({
            showCounter: this.showCounterSignal,
            promotionCount: this.promotionCount,
            valuedAtEnabled: Store.signal(this._settings.get('freeRoundsValuedAtEnabled'))
        }) as Container;

        this.container.addChild(frCounter);
    }

    protected onSetupEvents(): void {
        this.emitter.on('General.Promotion.ActivateCounter', this.onActivateCounter.bind(this));
        this.emitter.on('General.Promotion.ShowCounter', this.showCounter.bind(this));
        this.emitter.on('General.Promotion.HideCounter', this.hideCounter.bind(this));
        this.emitter.on('General.Promotion.UpdateCounter', this.updateCounter.bind(this));
        this.emitter.on('General.Promotion.DeactivateCounter', this.onDeactivateCounter.bind(this));
    }

    protected onActivateCounter(data: CounterData): void {
        this.active = true;
        this.promotionCount.value = data;
        this.showCounter();
    }

    protected hideCounter(): void {
        this.showCounterSignal.value = false;
    }

    protected showCounter(): void {
        if (this.active) {
            this.showCounterSignal.value = true;
        }
    }

    protected updateCounter(data: CounterData): void {
        this.promotionCount.value = data;
    }

    protected onDeactivateCounter(): void {
        this.active = false;
        this.hideCounter();
    }
}